import { LinearProgress, Typography, linearProgressClasses, styled } from '@mui/material'

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#CCC',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#0070FF',
  },
}))

export const BinProgressBar = (props: {
  progress: { scanned: number; total: number; costScanned: number; totalCost: number }
}) => {
  console.log(props.progress)
  return (
    <>
      {props.progress.total > 0 ? (
        <>
          {' '}
          <div style={{ flex: 1 }}>
            <BorderLinearProgress value={100 * (props.progress.scanned / props.progress.total)} variant="determinate" />
          </div>
          <div>
            {props.progress.scanned} / {props.progress.total} item(s) accounted for, $
            {props.progress.totalCost - props.progress.costScanned} missing
          </div>
        </>
      ) : (
        <>
          <Typography fontStyle="italic" color="#AAA">
            No items directly in this bin
          </Typography>
          <div />
        </>
      )}
    </>
  )
}
